import dataStore from '../../data/data';

const Join = async () => {
  const data = dataStore.getState();
  const sessionId = data?.mirror?.sessionId;
  const vitruvianId = data?.mirror?.vitruvianId;

  if (!sessionId || !vitruvianId) {
    console.log('Missing sessionId or vitruvianId');
    return;
  }

  try {
    const res = await fetch(
      `${process.env.REACT_APP_PHI_WEB_URL}/mirror-cast-session-join`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          sessionId,
          vitruvianId,
        }),
      }
    );

    if (!res.ok) {
      throw new Error('Failed to join session');
    }

    return await res.json();
  } catch (err) {
    console.error('Join session error:', err);
  }
};

export default Join;